import { useQuery } from '@tanstack/react-query'
import { ITreatmentSchema } from 'models/ICattlesData'
import CattlesApiService from 'services/cattlesApiServices'

export const useGetTreatmentSchemas = () => {
	const { data, isLoading, error, refetch } = useQuery<ITreatmentSchema[]>({
		queryKey: ['treatmentSchemas'],
		queryFn: async () => {
			const response = await CattlesApiService.getTreatmentSchema()
			return response
		},
	})

	return { data, isLoading, error, refetch }
}
